import React from "react";
import Link from "next/link";
import Image from "next/image";
import Mobile from "@/components/navigation/Mobile";
import Desktop from "@/components/navigation/Desktop";
import HeaderBackground from "@/components/layouts/HeaderBackground";
import { SbBlokData, storyblokEditable } from "@storyblok/react";
import {
  AccreditationSmallSection,
  Header,
} from "@/.storyblok/types/319751/storyblok-components";
// import { logger } from '@/lib/logger';

interface HeaderProps {
  // videoBgUrl?: string;
  headerClass?: string;
  heroClass?: string;
  // showHero?: boolean;
  heroContent?: React.ReactNode;
  blok: Header & SbBlokData;
  trustsmall?: AccreditationSmallSection;
}

const HeaderComponent: React.FC<HeaderProps> = ({
  // videoBgUrl,
  headerClass = "",
  // showHero = true,
  heroContent,
  blok,
  trustsmall,
}) => {
  if (!blok) return null;

  const {
    logo,
    phone_number,
    cta_buttons = [],
    logo_link,
    video_background,
  } = blok || {};

  const phoneLink = phone_number ? `tel:${phone_number.trim()}` : "";

  // logger.log(`heroContent` + JSON.stringify(heroContent, null, 2));

  return (
    <div {...storyblokEditable(blok)} className={`header ${headerClass}`}>
      {!video_background?.filename && <HeaderBackground styleController={headerClass} />}

      {video_background?.filename && (
        <div className="header-video-wrapper">
          <video className="header-video-bg" playsInline autoPlay muted loop>
            <source
              src={video_background.filename.replace(".mp4", ".webm")}
              type="video/webm"
            />
            <source src={video_background.filename} type="video/mp4" />
          </video>
        </div>
      )}

      <nav className="navbar-sticky navbar navbar-dark" id="page-navigation">
        <div className="container">
          <div id="page-navigation-logo" className="me-2 me-md-3 me-xl-5 mb-0">
            <Link href={logo_link?.cached_url || "/"}>
              <Image
                src={logo?.filename || "/logo.svg"}
                alt={logo?.alt || "Logo"}
                width={824}
                height={562}
                className="navbar-brand d-block"
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                priority
                fetchPriority="high"
                quality={75}
              />
            </Link>
          </div>

          <Desktop blok={blok} trustsmall={trustsmall as AccreditationSmallSection & SbBlokData} />

          {/* CTA Section */}
          <div
            className="nav-cta rounded-pill ms-auto"
            id="page-navigation-additional"
          >
            <ul className="navbar-nav align-items-center flex-row flex-grow-1 text-white">
              {cta_buttons.map((button) => (
                <li
                  key={button._uid}
                  className="nav-item pe-3 pe-lg-0 ps-lg-3 order-lg-last"
                >
                  <Link
                    href={button.link?.cached_url || "#"}
                    className={`btn btn-${button.type} btn-sm rounded-pill js-cta-btn`}
                  >
                    {button.label}
                  </Link>
                </li>
              ))}
              {phone_number && (
                <li className="nav-item ps-lg-3">
                  <Link
                    href={phoneLink}
                    className="nav-icon nav-link text-white fw-bolder"
                    aria-label={`Call us at ${phone_number.trim()}`}
                  >
                    <i className="fas fa-phone fa-sm me-2" aria-hidden="true"></i>
                    <span className="d-none d-md-inline">
                      {phone_number.trim()}
                    </span>
                  </Link>
                </li>
              )}
              <li className="nav-item ps-3 pe-1 d-lg-none">
                <button
                  className="nav-icon offcanvas-toggler"
                  type="button"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#page-navigation-mobile"
                  aria-controls="page-navigation-mobile"
                  aria-label="Menu"
                >
                  <span className="offcanvas-toggler-icon"></span>
                  <span className="offcanvas-toggler-icon"></span>
                  <span className="offcanvas-toggler-icon"></span>
                </button>
              </li>
            </ul>
          </div>

          <Mobile blok={blok} />
        </div>
      </nav>

      {heroContent && (
        <div className="header-content">
          <div className="container">
            <div className="hero-wrapper py-5 py-xl-6">{heroContent}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HeaderComponent;
